module.exports = __webpack_public_path__ + "static/archie_logo_black-9945cd5b838492ade565d19721122c70.png";